import { RecurringTypesEnum } from "dash-common";
import { SubscriptionProduct } from "gql/generated.graphql";
import { ENABLE_YEARLY_PLANS } from "./SubscriptionComponents.constants";

/**
 * Filters subscription products based on ENABLE_YEARLY_PLANS feature flag
 * When yearly plans are enabled, filters out SIXMONTH products
 * When yearly plans are disabled, filters out YEAR products
 */
export function filterProductsByRecurringType(
  existingProducts: SubscriptionProduct[]
): SubscriptionProduct[] {
  if (ENABLE_YEARLY_PLANS) {
    // Use yearly products from backend - filter out SIXMONTH products
    return existingProducts.filter(
      (p) => p.recurringType !== RecurringTypesEnum.SIXMONTH
    );
  } else {
    // Use six-month products from backend - filter out YEAR products
    return existingProducts.filter(
      (p) => p.recurringType !== RecurringTypesEnum.YEAR
    );
  }
}
